import {
  Text
} from "@fluentui/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import './../assets/styles/layout.css';
import { common } from "../messages/common-items";

const SiteLayout: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [screenReady, setScreenReady] = useState(false);
  const { SuccessMessages: Success_Common } = common;

  useLayoutEffect(() => {
    const small = window.innerWidth < 768;
    setIsMobile(small);
    setCollapsed(small);
    setScreenReady(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const small = window.innerWidth < 768;
      setIsMobile(small);
      setCollapsed(small);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!screenReady) return null;

  return (
    <div className="app-layout">
      <div className={`header ${isMobile ? 'header-mobile' : 'header-desktop'}`}>
        <h3>{Success_Common.HEADER_TEXT}</h3>
      </div>
      <div className="footer">
        <Text variant="small">{Success_Common.FOOTER_TEXT}</Text>
      </div>
      <div className="layout-body">
        <div className="sitelayout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SiteLayout;